import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Caret Up Down Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M192.717 179.066c3.773 3.768 3.773 9.883 0 13.652l-57.892 57.892c-3.769 3.773-9.884 3.773-13.652 0L63.28 192.718c-5.255-5.255-2.851-14.228 4.327-16.151a9.65 9.65 0 0 1 9.325 2.498L128 230.144l51.065-51.077c3.77-3.774 9.884-3.774 13.653 0M76.933 76.934 128 25.856l51.065 51.078c5.255 5.254 14.228 2.85 16.152-4.328a9.65 9.65 0 0 0-2.499-9.325L134.825 5.39c-3.769-3.773-9.884-3.773-13.652 0L63.28 63.282c-5.255 5.255-2.851 14.228 4.327 16.151a9.65 9.65 0 0 0 9.325-2.499" }, null, -1)
  ]))]))
}
export default { render: render }